export default __webpack_public_path__ + "static/media/nav-chat-outline.bca5cc60.svg";